<template>
  <payment-review-modal
    id="internal-review-modal"
    :form-data="modal.data.formData"
    :transaction-type="modal.data.transactionType"
    :fee-amount="modal.data.feeAmount"
  >
    <data-divider />
    <profile-data-in-modal
      :transaction-party-type="TRANSACTION_PARTY_TYPES.SENDER"
      :profile="modal.data.sender"
      :selected-account="modal.data.senderAccount"
    />
    <data-divider />
    <profile-data-in-modal
      :transaction-party-type="TRANSACTION_PARTY_TYPES.RECIPIENT"
      :profile="modal.data.recipient"
      :selected-account="modal.data.recipientAccount"
    />
  </payment-review-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Constants
  import { TRANSACTION_PARTY_TYPES } from '@/models/Transaction'

  // Components
  import PaymentReviewModal from '@/components/payments/ReviewModal/PaymentReviewModal'
  import ProfileDataInModal from '@/components/payments/ReviewModal/ProfileDataInModal'
  import DataDivider from '@/components/payments/ReviewModal/DataDivider'

  export default {
    name: 'InternalReviewModal',
    components: {
      PaymentReviewModal,
      ProfileDataInModal,
      DataDivider
    },
    data () {
      return {
        TRANSACTION_PARTY_TYPES
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    }
  }
</script>
